import { Card, CardActions, CardContent, CardHeader, Grid, IconButton, Modal, Stack, Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetDate, GetTime } from '../../app/AppUtils';
import SearchStudentRemarkCard from '../search/student/SearchStudentRemarkCard';
import { deleteStudentRemark } from '../search/student/searchStudentSlice';
import ConfirmationModal from '../subcomponents/ConfirmationModal';

import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function ProgressRemarks({ remarks }) {

    return (
        <Grid container spacing={1} sx={{ mt: 1 }}>
            {remarks.map((item, index) =>
                <Grid size={{ xs: 12 }} key={index}>
                    <RemarkCard item={item} />
                </Grid>
            )}
        </Grid>
    );
}

const RemarkCard = ({ item }) => {
    const dispatch = useDispatch();

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const [expanded, setExpanded] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);

    const callbackModal = () => {
        setOpenEdit(false);
    };

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const handleEditClick = () => {
        setOpenEdit(!openEdit);
    };

    const handleDeleteClick = (remarkId) => {
        dispatch(deleteStudentRemark(remarkId));
    };

    return (
        <>
            <Card elevation={0} sx={{ bgcolor: 'white.light' }}>
                <CardHeader sx={{ p: 1 }}
                    titleTypographyProps={{ variant: 'body1' }}
                    subheaderTypographyProps={{ variant: 'body2', color: 'text.secondary' }}
                    title={item.authorName}
                    subheader={!!item.dateModified ?
                        `*${GetDate(item.dateModified)} (${GetTime(item.dateModified)})` :
                        `${GetDate(item.dateCreated)} (${GetTime(item.dateCreated)})`}
                />
                <CardContent sx={{ p: 1 }}>

                    <Typography
                        variant="body1"
                        sx={{
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            WebkitLineClamp: expanded ? 'unset' : 1,
                            whiteSpace: expanded ? 'normal' : 'unset',
                        }}
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.remarkText.replace(/\\n/g, '<br />')) }}
                    />
                </CardContent>
                <CardActions sx={{ display: 'flex', px: 1, py: 0, m: 0 }}>
                    <Stack direction="row" spacing={1} sx={{ display: 'flex', flexGrow: 1 }}>
                        {item.visibleForEmployee ? <CheckIcon color="text.secondary" /> : <ClearIcon color="text.secondary" />}<Typography variant="body2" sx={{ color: 'text.secondary', alignSelf: 'center' }}>{resourceFinal[appLanguage].messages.VISIBLE_FOR_EMPLOYEES}</Typography>
                        {item.visibleForStudent ? <CheckIcon color="text.secondary" /> : <ClearIcon color="text.secondary" />}<Typography variant="body2" sx={{ color: 'text.secondary', alignSelf: 'center' }}>{resourceFinal[appLanguage].messages.VISIBLE_FOR_STUDENTS}</Typography>
                    </Stack>
                    {item.remarkOwner && <>
                        <IconButton onClick={handleEditClick}>
                            <EditIcon color="secondary" />
                        </IconButton>
                        <ConfirmationModal
                            iconButton
                            icon={<DeleteIcon color="secondary" />}
                            message={`${resourceFinal[appLanguage].messages.DELETE_CONFIRMATION_1} ${resourceFinal[appLanguage].words.REMARK} ${resourceFinal[appLanguage].messages.DELETE_CONFIRMATION_2}`}
                            confirmAction={() => handleDeleteClick(item.id)}
                        />
                    </>}
                    <IconButton
                        onClick={handleExpandClick}
                        sx={{
                            transition: 'transform 0.3s ease',
                            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                        }}
                    >
                        <ExpandMoreIcon color="secondary" />
                    </IconButton>
                </CardActions>
            </Card>
            <Modal open={openEdit} onClose={callbackModal}>
                <>
                    <SearchStudentRemarkCard handleClose={callbackModal} selectedRemark={item} />
                </>
            </Modal>
        </>
    );
}